export default "__VITE_ASSET__D5LYeXQ4__"